module.exports = __webpack_public_path__ + "img/SM.a45297e4.png";